import { RolesLowerCase } from '../enums';

export const displayRole = (roleTitle: string) => {
  switch (roleTitle) {
    case RolesLowerCase.ORGANIZATION_ADMIN:
      return 'OA';
    case RolesLowerCase.ANALYST:
      return 'Analyst';
    case RolesLowerCase.VIEWER:
      return 'Viewer';
    case RolesLowerCase.SUPER_ADMIN:
      return 'SA';
    default:
      return '';
  }
};
